import { API_V2 } from './apiVersion';

export const USER_ENDPOINTS = {
  ME: `${API_V2}/users/me`,

  PROFILE: `${API_V2}/users/me/profile`,
  PROFILE_IMAGE: `${API_V2}/users/me/profile-image`,
  PROFILE_IMAGE_PRESIGN: `${API_V2}/users/me/profile-image/presign`,

  PASSWORD: `${API_V2}/users/me/password`,
  PASSWORD_CHECK: `${API_V2}/users/me/password/check`,

  FCM_TOKEN: `${API_V2}/users/me/fcm-token`,
} as const;
